import { render } from "./SuccesView.vue?vue&type=template&id=6796e7fd"
import script from "./SuccesView.vue?vue&type=script&lang=js"
export * from "./SuccesView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git_repos\\blendify\\blendify-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__